<template>
    <button type="button" :class="['ini-btn', 'btn', 'btn-'+type, {'btn--icon-text' : icon }]" @click="buttonClicked">
        <i v-if="icon" :class="'zmdi zmdi-'+icon"></i>  <slot></slot>
    </button>
</template>

<script>
    export default {
        props:{
            type: {
                default : 'primary',
                type:String
            },
            icon: String,
        },

        methods: {
            buttonClicked() {
                this.$emit('click')
            }
        }
    }
</script><style lang="scss">@import "@/assets/scss/components/_button.scss";</style>